import { render, staticRenderFns } from "./PayeeModal.vue?vue&type=template&id=65369069&scoped=true"
import script from "./PayeeModal.vue?vue&type=script&lang=js"
export * from "./PayeeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65369069",
  null
  
)

export default component.exports